import { render, staticRenderFns } from "./ConfirmLeadTable.vue?vue&type=template&id=3308d382"
import script from "./ConfirmLeadTable.vue?vue&type=script&lang=js"
export * from "./ConfirmLeadTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports